import api from 'services/api'
import {GET_SOCIETIES, GET_ROLES} from '../endpoints'

export const getSocieties = async () => await api.get(GET_SOCIETIES)
export const getRoles = async () => await api.get(GET_ROLES)
